import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import squall from "./../../assets/squall.png";
import Grid from "@mui/material/Unstable_Grid2";
import typhoon from "./../../assets/typhoon.png";
import forecast from "./../../assets/forecast.png";
import lighting from "./../../assets/lightning.png";
import quickOverview from "./../../assets/quick-overview.png";
import weatherWindow from "./../../assets/weather-window.png";
import satellite from "./../../assets/satpic.png";
import chart from "./../../assets/chart.png";
import ensemble from "./../../assets/ensemble.png";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import "./style.scss";
import axios from "axios";

interface CardData {
  name: string;
  url: string;
  image: string;
  content: React.ReactNode;
  color?: string;
}
interface TrackData {
  storm_track_id: number;
  storm_name: string;
  storm_description: string | null;
  status_id: number;
  created_by: number;
  created_on: string;
  updated_by: number | null;
  updated_on: number | null;
  last_accessed_on: string;
}
const CardPlan: React.FC = () => {
  const [data, setData] = useState<CardData[]>([]);
  const [stormData, setStormData] = useState<any>([]);
  //const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [trackData, setTrackData] = useState<TrackData | null>(null);
  const [hasMapHovers, setHasMapHovers] = useState(false);
  const [loadedDatas, setLoadedDatas] = useState(false);
  const [mapHovers, setMapHovers] = useState<{ [key: string]: any }>({});

  const [jsonData, setJsonData] = useState<any>();
  const [title, setTitle] = useState("");
  const [color, setColor] = useState("green");
  const [squallLastUpdated, setSquallLastUpdated] = useState<string>("");

  const [pdfStatus, setPdfStatus] = useState<any>({ Typhoon: false });
  const [loading, setLoading] = useState<{ [key: string]: boolean }>({});

  const [projectLocation, setProjectLocation] = useState<string>(() => {
    return (
      localStorage.getItem("project_location") ||
      localStorage.getItem("location") ||
      localStorage.getItem("project") ||
      ""
    );
  });

  const checkPdfAvailability = async () => {
    try {
      const project = localStorage.getItem("project");
      const location =
        localStorage.getItem("project_location") ||
        localStorage.getItem("location") ||
        localStorage.getItem("project") ||
        "";

      if (!project || !location) {
        //console.log("No project or location found");
        setPdfStatus((prevStatus: any) => ({
          ...prevStatus,
          Typhoon: false,
        }));
        return;
      }

      if (
        !trackData ||
        (Array.isArray(trackData) && trackData.length === 0) ||
        (!Array.isArray(trackData) && !trackData.storm_name)
      ) {
        setPdfStatus((prevStatus: any) => ({ ...prevStatus, Typhoon: false }));
        return;
      }
      const names = Array.isArray(trackData)
        ? trackData.map((track) => track.storm_name)
        : trackData.storm_name
        ? [trackData.storm_name]
        : [];

      if (names.length === 0) {
        setPdfStatus((prevStatus: any) => ({
          ...prevStatus,
          Typhoon: false,
        }));
        return;
      }

      const axiosConfig = {
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_IP}/api/checkpdftyphoon/`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          location: location,
          storm_name: names,
        },
        timeout: 3000,
      };

      const response = await axios(axiosConfig);

      if (response.status === 200 && response.data) {
        const { count, files } = response.data;

        const parsedFiles = files
          ? files.map((fileItem: any) => {
              const filename =
                typeof fileItem === "string" ? fileItem : fileItem.filename;
              const match = filename.match(
                /TC_BULLETIN_([^-]+)-([^-]+)-([^-]+)/
              );
              if (match) {
                const [, stormName, fileLocation, projectName] = match;
                return {
                  filename: filename,
                  storm_name: stormName.trim(),
                  location: fileLocation.trim(),
                  project: projectName.trim(),
                };
              }

              const extractStormName = (filename: string): string => {
                if (filename.includes("-")) {
                  const match = filename.match(/TC_BULLETIN_([^-]+)/);
                  return match ? match[1] : filename;
                } else {
                  const match = filename.match(/TC_BULLETIN_(.+)/);
                  return match ? match[1] : filename;
                }
              };

              return {
                filename: filename,
                storm_name: extractStormName(filename),
                location: filename,
                project: project,
              };
            })
          : [];

        const locationMatchingFiles = parsedFiles.filter((fileData: any) => {
          return (
            fileData.location.toUpperCase().includes(location.toUpperCase()) ||
            location.toUpperCase().includes(fileData.location.toUpperCase())
          );
        });

        const locationSpecificCount = locationMatchingFiles.length;
        const hasLocationSpecificPdf = locationSpecificCount > 0;

        // console.log(`Current location: ${location}`);
        // console.log(`Total PDF files: ${count} (all locations)`);
        // console.log(`Parsed PDF files:`, parsedFiles);
        // console.log(`Location-specific PDF count: ${locationSpecificCount}`);
        // console.log(`Location-specific PDFs:`, locationMatchingFiles);
        // console.log(`Status for ${location}: ${hasLocationSpecificPdf ? 'RED' : 'GREEN'}`);

        setPdfStatus((prevStatus: any) => ({
          ...prevStatus,
          Typhoon: hasLocationSpecificPdf,
        }));
      } else {
        setPdfStatus((prevStatus: any) => ({
          ...prevStatus,
          Typhoon: false,
        }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response && error.response.status === 404) {
          setPdfStatus((prevStatus: any) => ({
            ...prevStatus,
            Typhoon: false,
          }));
        } else {
          setPdfStatus((prevStatus: any) => ({
            ...prevStatus,
            Typhoon: false,
          }));
        }
      } else {
        setPdfStatus((prevStatus: any) => ({
          ...prevStatus,
          Typhoon: false,
        }));
      }
    }
  };

  useEffect(() => {
    checkPdfAvailability();
    const intervalId = setInterval(checkPdfAvailability, 5000);
    return () => clearInterval(intervalId);
  }, [trackData, projectLocation]);

  useEffect(() => {
    fetchStormData();
  }, []);
  useEffect(() => {
    if (trackData) {
      fetchLastEditedData();
    }
  }, [trackData, pdfStatus]);

  useEffect(() => {
    if (!loadedDatas) {
      fetch(`${process.env.REACT_APP_BACKEND_IP}/api/stormdatas/`)
        .then((response) => response.json())
        .then((data) => {
          if (data.track_datas) {
            setStormData(data.track_datas);
          }
          if (data.map_hovers) {
            setMapHovers(data.map_hovers);
            setHasMapHovers(data.map_hovers.length > 0);
          } else {
            setHasMapHovers(false);
          }
          setLoadedDatas(true);
        })
        .catch(() => setLoadedDatas(true));
    }
  }, [loadedDatas]);

  const fetchStormData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_IP}/api/stormdatas`
      );
      const apiData = response.data;
      if (apiData.storm_datas.length === 0) {
        setStormData({
          name: "No storm data available",
          description: "Please check back later.",
        });
        //console.log("No storm data available.");
      } else {
        setStormData(apiData.storm_datas[0]);
        //console.log("Storm data set:", apiData.storm_datas[0]);
      }
      if (apiData.track_datas.length === 0) {
        setTrackData({
          storm_track_id: 0,
          storm_name: "No track data",
          storm_description: null,
          status_id: 0,
          created_by: 0,
          created_on: "N/A",
          updated_by: null,
          updated_on: null,
          last_accessed_on: "N/A",
        });
        //console.log("No track data available.");
      } else {
        const track = apiData.track_datas[0];
        setTrackData(track);
        //console.log("Track data set:", track);
      }
    } catch (error) {
      console.error("Error fetching storm data:", error);
    }
  };

  const returnTimeDifference = (date: string): string => {
    const pastDate = new Date(date);
    // Helper to pad single digits with a leading zero
    const pad = (n: number): string => (n < 10 ? "0" + n : n.toString());
    const day = pad(pastDate.getDate());
    const month = pad(pastDate.getMonth() + 1); // Months are 0-based
    const year = pastDate.getFullYear();
    const hours = pad(pastDate.getHours());
    const minutes = pad(pastDate.getMinutes());
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_IP}/api/getcsv/${localStorage.fid}`
        );
        if (
          response.status === 404 ||
          !response.data ||
          response.data.length === 0
        ) {
          setTitle(
            "There are currently no severe warnings active for this location"
          );
          setColor("green");
          setSquallLastUpdated("");
        } else {
          const csvText = response.data;
          setJsonData(csvText);
          setTitle(csvText[0]["Squall Header"]);
          setColor("red");          
          // Get the file modification time from backend
          if (csvText[0]["Last_Modified"]) {
            setSquallLastUpdated(csvText[0]["Last_Modified"]);
          }
        }
      } catch (error: any) {
        setTitle("Error fetching data");
        setColor("green");
        setSquallLastUpdated("");
      }
    };
    fetchData();
  }, []);

  const fetchLastEditedData = async () => {
    const fid = localStorage.getItem("fid");
    const typhoonColor = hasMapHovers ? "animate-blink-red" : "green";
    if (fid) {
      try {
        const response = await axios.get(
          `${
            process.env.REACT_APP_BACKEND_IP
          }/api/lastedited/${localStorage.getItem("fid")}`
        );
        const lastEditedData = response.data;
        //console.log("respose ==>",response.data,pdfStatus)
        const cardData: CardData[] = [
          {
            name: "Forecast",
            url: "forecast",
            image: forecast,
            content: lastEditedData.forecast
              ? `Latest Updated: ${returnTimeDifference(
                  lastEditedData.forecast
                )}`
              : "",
          },
          {
            name: "Graphical Forecast",
            url: "overview",
            image: quickOverview,
            content: lastEditedData.forecast
              ? `Latest Updated: ${returnTimeDifference(
                  lastEditedData.forecast
                )}`
              : "",
          },
          {
            name: "Weather Window",
            url: "weather",
            image: weatherWindow,
            content: lastEditedData.forecast
              ? `Latest Updated: ${returnTimeDifference(
                  lastEditedData.forecast
                )}`
              : "",
          },
          {
            name: "Squall",
            url: "squall",
            image: squall,
            content:
              color === "red" && squallLastUpdated
                ? `Updated ${returnTimeDifference(squallLastUpdated)}`
                : "Update every 6 hours",
            color: color,
          },
          {
            name: "Tropical Cyclone",
            url: "typhoon",
            image: typhoon,
            content:
              trackData?.status_id === 8
                ? `Updated ${returnTimeDifference(
                    trackData.last_accessed_on
                  )}`
                : "",
            color:
              pdfStatus["Typhoon"] &&
              trackData &&
              trackData.storm_name !== "No track data" &&
              trackData.storm_name?.trim() !== ""
                ? "red"
                : "green",
          },
          {
            name: "Satellite",
            url: "satellite",
            image: satellite,
            content: "Update every 10min",
            //color: "green",
          },
          {
            name: "Ensemble and probability",
            url: "dashboard",
            image: ensemble,
            content: (
              <span style={{ fontSize: "10px" }}>under construction</span>
            ),
            // color: "green",
          },
          {
            name: "Charts",
            url: "charts",
            image: chart,
            content: "",
            // color: "green",
          },
          {
            name: "Nowcast",
            url: "dashboard",
            image: squall,
            content: (
              <span style={{ fontSize: "10px" }}>under construction</span>
            ),
            // color: "green",
          },
          {
            name: "Navigator",
            url: "dashboard",
            image: squall,
            content: (
              <span style={{ fontSize: "10px" }}>under construction</span>
            ),
            // color: "green",
          },
          {
            name: "Archives",
            url: "dashboard",
            image: squall,
            content: (
              <span style={{ fontSize: "10px" }}>under construction</span>
            ),
            // color: "green",
          },
          {
            name: "Glossary",
            url: "dashboard",
            image: squall,
            content: (
              <span style={{ fontSize: "10px" }}>under construction</span>
            ),
            // color: "green",
          },
        ];
        setData(cardData);
      } catch (error) {
        console.error("Error fetching last edited data:", error);
      }
    } else {
      const defaultCardData: CardData[] = [
        {
          name: "Forecast",
          url: "forecast",
          image: forecast,
          content: "No data available",
        },
        {
          name: "Quick Overview",
          url: "overview",
          image: quickOverview,
          content: "No data available",
        },
        {
          name: "Weather Window",
          url: "weather",
          image: weatherWindow,
          content: "No data available",
        },
        {
          name: "Squall",
          url: "squall",
          image: squall,
          content: "",
          color: "green",
        },
        {
          name: "Typhoon",
          url: "typhoon",
          image: typhoon,
          content: "No data available",
          color: "green",
        },
        {
          name: "Lightning",
          url: "lightning",
          image: lighting,
          content: "",
          color: "green",
        },
      ];
      setData(defaultCardData);
      // console.log("Default card data set:", defaultCardData);
    }
  };

  return (
    <>
      {data.map((item: CardData) => (
        <Grid key={item.name} xs={12} sm={6} md={6} lg={4}>
          <Link to={`/${item.url}`} state={{ title: item.name }}>
            <div className={"hoverable"}>
              <CardMedia
                className="card-img"
                sx={{ height: 100 }}
                image={item.image}
                title={item.name}
                style={{ borderRadius: "10px" }}
              />
              <Card
                className="parent_card"
                style={{
                  borderRadius: "10px",
                  backgroundColor: "#003366",
                  color: "white",
                }}
              >
                <CardContent
                  className="child_card"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="div"
                      sx={{ fontSize: "0.9rem" }}
                    >
                      {item.name}
                    </Typography>
                    <Typography variant="body2" color="white">
                      {item.content}
                    </Typography>
                  </div>
                  {item.color && (
                    <span
                      className={`color_icon ${
                        item.color === "red"
                          ? "color_icon_red blinking-circle"
                          : `color_icon_${item.color}`
                      }`}
                    ></span>
                  )}
                </CardContent>
              </Card>
              {/* <Card className="parent_card" style={{ borderRadius: "10px" }}>
                <CardContent
                  className="child_card"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="div"
                      sx={{ fontSize: "0.9rem" }}
                    >
                      {item.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.content}
                    </Typography>
                  </div>
                  {item.color && (
                    <span
                      className={`color_icon ${
                        item.color === "red"
                          ? "color_icon_red blinking-circle"
                          : `color_icon_${item.color}`
                      }`}
                    ></span>
                  )}
                </CardContent>
              </Card> */}
            </div>
          </Link>
        </Grid>
      ))}
    </>
  );
};

export default CardPlan;